import PropTypes from 'prop-types';
import React, { Children, useEffect, useState } from 'react';
import useFilters from '../../hooks/useFilters.js';
import { fillObject, hasKeys, hasValues } from '../../utils/Utils.js';
import AdvancedFilters from './Advanced/AdvancedFilters.inner.js';

import * as S from './Filters.styles';

import FiltersChilds from './FiltersChilds.inner.js';
import FiltersPills from './Pills/FiltersPills.inner.js';
import { Provider as FilterContext } from './FilterContext.inner.js';
import Button from '../Button/Button';

const Filters = ({
  onChange,
  children,
  initialValue,
  currencyCode = 'ARS',
  showPills = true,
  invertAdvancedFilterPosc,
}) => {
  const {
    filters: allFilters,
    setFilter,
    addFilters,
  } = useFilters(initialValue);

  const { advanced, ...filters } = allFilters;

  const mergedFilters = { ...filters, ...advanced };

  const [openAdvancedFilters, setOpenAdvancedFilters] = useState(false);

  const handleApplyFilters = () => {
    onChange && onChange(mergedFilters);
  };

  useEffect(() => {
    hasKeys(mergedFilters) && handleApplyFilters();
  }, [allFilters]);

  const { normalFilters, advancedFilters } = getFiltersChildrens(children);

  const handleAdvancedFiltersChange = (filters) => {
    addFilters(filters);
    setOpenAdvancedFilters(false);
  };

  const handleAdvancedCancel = () => {
    setOpenAdvancedFilters(false);
  };

  const removeAdvancedFilter = (name) =>
    addFilters({ advanced: { ...advanced, [name]: null } });

  const clearAdvancedFilters = () => {
    addFilters({
      ...filters,
      advanced: fillObject(advanced, null),
    });
  };
  return (
    <FilterContext value={{ filters, setFilter }}>
      <S.FilterWrapper>
        <FiltersChilds setFilter={setFilter} filters={filters}>
          {normalFilters}
        </FiltersChilds>
        {advancedFilters && (
          <S.AdvancedButtonWrapper>
            <Button
              onClick={() => setOpenAdvancedFilters((open) => !open)}
              icon='sliders_outline'
              size='md'
              variant='secondary'
              iconAlign='right'
            >
              Filtros
            </Button>

            <AdvancedFilters
              filters={advanced}
              open={openAdvancedFilters}
              onChange={handleAdvancedFiltersChange}
              onCancel={handleAdvancedCancel}
              invertPosition={invertAdvancedFilterPosc}
            >
              {advancedFilters}
            </AdvancedFilters>
          </S.AdvancedButtonWrapper>
        )}
      </S.FilterWrapper>
      {showPills && hasValues(advanced) && (
        <FiltersPills
          filters={advanced}
          removeFilter={removeAdvancedFilter}
          clearFilters={clearAdvancedFilters}
          currencyCode={currencyCode}
        />
      )}
    </FilterContext>
  );
};

const getFiltersChildrens = (children) => {
  let filtersChildrens = Children.toArray(children);

  const indexAdvancedFilter = filtersChildrens.findIndex(
    (component) => component.type.displayName === 'AdvancedFilters'
  );
  const hasAdvancedFilter = filtersChildrens.find(
    (component) => component.type.displayName === 'AdvancedFilters'
  );

  let advancedFilters = null;
  let normalFilters = [...filtersChildrens];

  if (hasAdvancedFilter) {
    advancedFilters = filtersChildrens[indexAdvancedFilter].props.children;
    normalFilters = [
      ...filtersChildrens.slice(0, indexAdvancedFilter),
      ...filtersChildrens.slice(indexAdvancedFilter + 1),
    ];
  }
  return { normalFilters, advancedFilters };
};

Filters.protoTypes = {
  onChange: PropTypes.func,
};

export default Filters;
